module.exports = __webpack_public_path__ + "img/footer-qrcode-wechat.0a364bda.png";